import { render, staticRenderFns } from "./AddEditCase.vue?vue&type=template&id=7c6b70ae&scoped=true"
import script from "./AddEditCase.vue?vue&type=script&lang=js"
export * from "./AddEditCase.vue?vue&type=script&lang=js"
import style0 from "./AddEditCase.vue?vue&type=style&index=0&id=7c6b70ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6b70ae",
  null
  
)

export default component.exports